import React from 'react';
import { CoverageBox, CoverageBoxPills, replaceStr } from 'flos-react-cvi';

function getTerminateInsuranceMessage(resources, terminationInfo) {
    const baseMessage = replaceStr(resources['receipt.terminateInsuranceTrue'], {
        '{product}': terminationInfo.product,
        '{company}': terminationInfo.company
    });

    if (terminationInfo.insuranceNumber) {
        return (
            baseMessage +
            ` ${replaceStr(resources['receipt.terminateInsuranceTrue.insuranceNumber'], {
                '{number}': terminationInfo.insuranceNumber
            })}`
        );
    }

    return baseMessage;
}

export const ReceiptBox = ({
    resources,
    insurances,
    title,
    subtitle,
    dealPrice,
    id,
    icon,
    customer,
    startDate,
    terminationInfo
}) => {
    if (!insurances || !insurances.length) {
        return null;
    }

    return (
        <CoverageBox
            title={title}
            subtitle={
                <>
                    <span style={{ fontSize: '14px' }}>{subtitle}</span>
                    <span style={{ display: 'block', marginTop: '10px' }}>
                        <span>
                            {resources['receipt.validFrom']} {startDate}
                        </span>
                        <br />
                        <span>
                            {terminationInfo.shouldTerminate
                                ? getTerminateInsuranceMessage(resources, terminationInfo)
                                : resources['receipt.terminateInsuranceFalse']}
                        </span>
                    </span>
                </>
            }
            id={id}
            svgIcon={icon}
            svgIconSize="medium"
            iconIsResponsive={false}
            actions={
                <div>
                    {dealPrice} {resources['receipt.priceRate']}
                </div>
            }
            pills={insurances.map(insurance => (
                <CoverageBoxPills key={insurance.nameId}>{insurance.name}</CoverageBoxPills>
            ))}
        />
    );
};
